import React from "react";
import Button from "react-md/lib/Buttons/Button";
import PropTypes from "prop-types";
import { getUserType, RegistrationShape } from "../../utils";

const ChangeLaneAssigment = ({
  assignment,
  onBackToQueue,
  onClearToCheckout,
}) => (
  <div className="md-grid" style={{ paddingTop: 20 }}>
    {assignment.group &&
      assignment.group.length > 0 &&
      assignment.group.map(
        /* eslint-disable no-confusing-arrow */
        // prettier auto remove surrouding () which need to avoid this lint error
        (user, i) =>
          i === 0 ? (
            /* eslint-enable no-confusing-arrow */
            // There is no unique parameter (firstName and lastName of user may be the same)
            //     so we use index for key
            /* eslint-disable react/no-array-index-key */
            <h6 className="md-cell md-cell--12 md-body-2" key={i}>
              {`${user.firstName} ${user.lastName}`}{" "}
              {getUserType(user) && `- ${getUserType(user)}`}
            </h6>
          ) : (
            <span className="md-cell md-cell--12" key={i}>
              {/* eslint-enable react/no-array-index-key */}
              {`${user.firstName} ${user.lastName}`}{" "}
              {getUserType(user) && `- ${getUserType(user)}`}
              <br />
            </span>
          )
      )}
    <div className="md-cell md-cell--12">
      <Button primary raised onClick={onBackToQueue}>
        Back To Queue
      </Button>
      <Button
        primary
        raised
        onClick={onClearToCheckout}
        style={{ marginLeft: "1em" }}
      >
        Clear To Checkout
      </Button>
    </div>
  </div>
);

ChangeLaneAssigment.propTypes = {
  assignment: RegistrationShape.isRequired,
  onBackToQueue: PropTypes.func.isRequired,
  onClearToCheckout: PropTypes.func.isRequired,
};

export default ChangeLaneAssigment;



// WEBPACK FOOTER //
// ./src/staff/components/LaneDrawer/ChangeLaneAssigment.jsx